import Vue from 'vue'
export default {
	setOffset(state,arg){	
		Vue.set(state.offsets,arg.key,arg.value);
	},
	// 登录成功，设置用户信息数据
	setLoginInfo(state,arg){
		state.loginInfo = arg;
		state.isLogin = true;
	},
	// 退出登录，清除数据
	clearUserInfo(state){ 
		state.loginInfo = {};
		state.isLogin = false;
  },
	setPublicData(state,arg){
		//頭尾數據，圖片，是否登錄等信息	
		state.top = arg.top;
		state.nav = arg.nav;
		state.imglist = arg.imglist || {};
		//設置登錄信息
		// if(arg.isLogin){
		// 	this.commit("setLoginInfo",arg.top.account)
		// }		
	},
	setLanguageChange(state,arg){
		if(arg.key) state.languageKey[arg.key] = arg.data;
	},
	//設置路由信息
	setRouteInfo(state,arg){
		let to = arg.to;
		if(to.meta.stay){
			state.quote.stay = to.meta.stay;
		}
	},
	setIsFixed(state, flag){
		state.isFixed = flag
	},
	setIsMinWidth(state, flag){
		state.isMinWidth = flag
	},
	setChangeType(state, flag){
		state.isChangeType = flag
	},
	setPcbPageData(state, data){
		state.pcbPageData = data
	},
	setIsFromPcb(state, flag){
		state.isFromPcb = flag
	},
	setIsChangeParams(state, flag){
		state.isChangeParams = flag
	},
	setChangeParams(state, data){
		state.changeParams = data
	},
	setIsLoadingPage(state, value) {
		state.isLoadingPage = value
	}
}